/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import { create } from "zustand"
import Cookies from "js-cookie"

/* -------------------------------------------------------------------------- */
/*                                    Utils                                   */
/* -------------------------------------------------------------------------- */
import { bankersWithWebsites } from "@utils/mb"

/* -------------------------------------------------------------------------- */
/*                                    Store                                   */
/* -------------------------------------------------------------------------- */
export const useBankerStore = create((set, get) => ({
  banker: null,
  getBanker: props => {
    if (get().banker) return get().banker
    let banker
    if (!props.isMounted && (props?.params?.mb || props?.pageContext?.slug)) {
      banker = bankersWithWebsites.find(mb => {
        return (
          props.params?.mb === mb.slug || props.pageContext?.slug === mb.slug
        )
      })

    } else if (props.isMounted) {
      const params = new URLSearchParams(window.location.search)
      const nmlsParam = params.get("mb_nmls")
      const nmlsCookie = Cookies.get("mb_nmls")
      banker = bankersWithWebsites.find(mb => {
        if (props.params?.mb) return props.params?.mb === mb.slug
        else if (props.pageContext?.slug) return props.pageContext?.slug === mb.slug
        else if (props?.path?.split("/")[1] === mb.slug) return true
        else if (mb.nmls && mb.nmls === nmlsParam) return true
        else if (mb.nmls && mb.nmls === nmlsCookie) return true
        return false
      })
      if (banker && nmlsCookie !== banker.nmls) Cookies.set("mb_nmls", banker.nmls)

      // if (banker && nmlsCookie !== banker.nmls)
      //   Cookies.set("mb_nmls", banker.nmls)
      // if (nmlsParam) {
      //   if (nmlsCookie && nmlsCookie !== nmlsParam && !banker) {
      //     Cookies.set("mb_nmls", nmlsParam)
      //   }
      //   nmls = nmlsParam
      // } else if (nmlsCookie) nmls = nmlsCookie
      // if (!banker) {
      //   banker = bankersWithWebsites.find(mb => {
      //     return mb.nmls === nmls || props?.path?.split("/")[1] === mb.slug
      //   })
      // }
    }

    return banker
  },
  setBanker: newBanker => {
    if (newBanker) Cookies.set("mb_nmls", newBanker.nmls)
    else Cookies.remove("mb_nmls")
    set({ banker: newBanker })
  },
}))
